import { Heading } from '@chakra-ui/react'
import React, { useCallback, useEffect, useState } from 'react'
import ChangeRole from './ChangeRole'
import axios from 'axios'
import { useSelector } from 'react-redux'


const SuperAdmin = () => {
    const user = useSelector((state) => state.user.userData);
    const [data, setData] = useState([]);

    const getAllUserAll = useCallback(() => {
        const params = {
            userId: user.userId,
        };
        axios.get(`http://18.132.190.48:8080/api/v1/getAllUserAll`, { params })
            .then((r) => {
                console.log("object, data", r)
                setData(r.data);
            })
            .catch((err) => console.log(err));
    }, [user.userId]);

    useEffect(() => {
        getAllUserAll()
    }, [])

    return (
        <>
            <Heading textAlign="center" mt={5} textDecoration={"underline"}>List of All user</Heading>
            <ChangeRole ownerData={data} />
        </>
    )
}

export default SuperAdmin
